import { NavLink, useLocation } from "react-router-dom";
import { Home, Calendar, IdCard, Award, User } from "lucide-react";

const items = [
  { to: "/home", label: "Início", icon: Home, testid: "bottom-nav-home" },
  { to: "/calendario", label: "Cursos", icon: Calendar, testid: "bottom-nav-cursos" },
  { to: "/carteira", label: "Carteira", icon: IdCard, testid: "bottom-nav-carteira" },
  { to: "/certificados", label: "Certif.", icon: Award, testid: "bottom-nav-certificados" },
  { to: "/perfil", label: "Perfil", icon: User, testid: "bottom-nav-perfil" },
];

export function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[hsl(var(--border))] bg-white/95 backdrop-blur"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-[520px] mx-auto grid grid-cols-5 h-[68px]">
        {items.map((it) => {
          const Icon = it.icon;
          const active = pathname === it.to || (it.to !== "/home" && pathname.startsWith(it.to));
          return (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={"flex flex-col items-center justify-center gap-1 px-1 " + (active ? "text-[hsl(var(--accent))]" : "text-muted-foreground") }
            >
              <div className={"flex items-center justify-center w-9 h-9 rounded-xl " + (active ? "bg-[hsl(var(--accent)/0.1)]" : "") }>
                <Icon className={"w-5 h-5"} />
              </div>
              <span className={"text-[10.5px] font-medium " + (active ? "text-[hsl(var(--accent))]" : "text-muted-foreground") }>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
